import React from 'react';
import { motion } from 'framer-motion';
import { Calculator, Calendar, Gift, CheckCircle2 } from 'lucide-react';
export function BonusSection() {
  const bonuses = [{
    icon: Calculator,
    tag: 'BONO #1',
    value: '$1.500 UYU',
    title: 'Calculadora de Costos en Pesos',
    subtitle: 'Dejá de adivinar cuánto cobrar',
    description: 'Una planilla lista para usar donde ingresás el costo de los hilos, el tiempo que tardás y te da el precio justo automáticamente. Incluye fórmulas para mano de obra, materiales y ganancia. Ideal si vendés en ferias o por redes.',
    points: ['Precio sugerido por prenda en UYU', 'Cálculo de ganancia real', 'Adaptada al mercado uruguayo']
  }, {
    icon: Calendar,
    tag: 'BONO #2',
    value: '$900 UYU',
    title: 'Calendario de Ferias Uruguay 2026',
    subtitle: 'Sabé dónde vender antes que nadie',
    description: 'Guía actualizada con las principales ferias y eventos de artesanías y diseño en Uruguay durante 2026. Incluye fechas, ubicaciones, cómo inscribirse y tips para preparar tu stand.',
    points: ['Ferias en Montevideo e interior', 'Fechas y requisitos de inscripción', 'Tips para vender más en cada evento']
  }];
  return <section className="py-10 md:py-20 bg-[#3D2B1F] text-[#FAF7F4] relative overflow-hidden" data-id="element-59">
      {/* Subtle background texture */}
      <div className="absolute inset-0 opacity-[0.04]" style={{
      backgroundImage: 'radial-gradient(#C17B5C 1px, transparent 1px)',
      backgroundSize: '24px 24px'
    }} data-id="element-60" />

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-61">
        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10 md:mb-14" data-id="element-62">
          <span className="inline-flex items-center gap-2 bg-[#C17B5C]/20 text-[#D4A5A5] text-xs font-bold uppercase tracking-widest px-4 py-1.5 rounded-full mb-4" data-id="element-63">
            <Gift className="w-3.5 h-3.5" data-id="element-64" />
            Solo con tu compra hoy
          </span>
          <h2 className="text-2xl md:text-4xl font-bold text-[#FAF7F4] mb-3" data-id="element-65">
            2 bonos gratis incluidos
          </h2>
          <p className="text-[#B09B8C] text-sm md:text-base max-w-xl mx-auto" data-id="element-66">
            Además de la biblioteca completa, recibís estos dos recursos extra
            sin costo adicional. Valorados en más de $2.400 UYU.
          </p>
        </motion.div>

        {/* Bonus cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-7" data-id="element-67">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.15
        }} className="bg-[#4A3525] rounded-2xl border border-[#5C4230] overflow-hidden" data-id="element-68">
              {/* Top bar */}
              <div className="flex items-center justify-between px-5 py-3 bg-[#5C4230]/60 border-b border-[#5C4230]" data-id="element-69">
                <span className="text-[#C17B5C] text-xs font-extrabold uppercase tracking-widest" data-id="element-70">
                  {bonus.tag}
                </span>
                <span className="text-[#FAF7F4] text-xs font-bold bg-[#C17B5C] px-2.5 py-1 rounded-md" data-id="element-71">
                  Valor: {bonus.value}
                </span>
              </div>

              {/* Body */}
              <div className="p-5 md:p-7" data-id="element-72">
                <div className="flex items-start gap-4 mb-4" data-id="element-73">
                  <div className="flex-shrink-0 w-11 h-11 rounded-xl bg-[#5C4230] flex items-center justify-center" data-id="element-74">
                    <bonus.icon className="w-5 h-5 text-[#C17B5C]" data-id="element-75" />
                  </div>
                  <div data-id="element-76">
                    <h3 className="text-base md:text-lg font-bold text-[#FAF7F4] leading-snug" data-id="element-77">
                      {bonus.title}
                    </h3>
                    <p className="text-xs text-[#C17B5C] font-semibold mt-0.5" data-id="element-78">
                      {bonus.subtitle}
                    </p>
                  </div>
                </div>

                <p className="text-sm text-[#B09B8C] leading-relaxed mb-4" data-id="element-79">
                  {bonus.description}
                </p>

                <ul className="space-y-2" data-id="element-80">
                  {bonus.points.map((point, i) => <li key={i} className="flex items-start gap-2 text-sm text-[#D4C4B8]" data-id="element-81">
                      <CheckCircle2 className="w-4 h-4 text-[#C17B5C] flex-shrink-0 mt-0.5" data-id="element-82" />
                      {point}
                    </li>)}
                </ul>
              </div>
            </motion.div>)}
        </div>

        {/* Total value summary */}
        <motion.div initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.3
      }} className="mt-8 text-center" data-id="element-83">
          <p className="text-[#B09B8C] text-sm" data-id="element-84">
            Valor total de los bonos:{' '}
            <span className="line-through text-[#6B5A4E]" data-id="element-85">$2.400 UYU</span>{' '}
            <span className="text-[#FAF7F4] font-bold" data-id="element-86">GRATIS</span> al comprar
            hoy
          </p>
        </motion.div>
      </div>
    </section>;
}